module.exports = __webpack_public_path__ + "static/ddbcd8618b5319b218de40283281932c79363eca400578390245a87294349bb6-1a31aea48905d7c08b9405d67844c5b3.jpeg";